export enum UserStatus {
  ACTIVE = 'active',
  INVITED = 'invited'
}
